import { render, staticRenderFns } from "./RitualCircleHome.vue?vue&type=template&id=941504b6"
import script from "./RitualCircleHome.vue?vue&type=script&lang=js"
export * from "./RitualCircleHome.vue?vue&type=script&lang=js"
import style0 from "./RitualCircleHome.vue?vue&type=style&index=0&id=941504b6&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Dev\\WorldManager\\src\\WorldManager.Web\\client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('941504b6')) {
      api.createRecord('941504b6', component.options)
    } else {
      api.reload('941504b6', component.options)
    }
    module.hot.accept("./RitualCircleHome.vue?vue&type=template&id=941504b6", function () {
      api.rerender('941504b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ritualCircles/RitualCircleHome.vue"
export default component.exports